module.exports = __webpack_public_path__ + "static/media/person.68c44ce8.jpg";